import { useEffect } from "react";

/**
 * Early-2000s style cursor trail — Comet Cursor meets MSN Messenger.
 * Bigger, chunkier, spaced-out particles for a more clunky late-90s feel.
 */
const SYMBOLS = ["♪", "♫", "♬", "★", "✦", "✧", "◆", "●", "♩"];
const COLORS = ["#FFEB3B", "#B6FF00", "#32CD32", "#3A93FF", "#FF85C2", "#FF8C2E", "#FFFFFF"];

export default function SparkleCursor({ enabled = true }) {
  useEffect(() => {
    if (!enabled) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let last = 0;
    let running = true;

    const onMove = (e) => {
      const now = Date.now();
      // Spawn less frequently (every ~110ms) for that clunky Comet Cursor feel
      if (now - last < 110) return;
      last = now;

      const el = document.createElement("span");
      el.className = "sparkle-particle";
      el.textContent = SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];
      el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];
      // Offset larger so each particle is clearly separated from the cursor
      el.style.left = `${e.clientX - 10 + (Math.random() * 12 - 6)}px`;
      el.style.top = `${e.clientY - 10 + (Math.random() * 8 - 4)}px`;
      // Bigger symbols (16–26px) so they read as chunky pixel art
      el.style.fontSize = `${16 + Math.random() * 10}px`;
      document.body.appendChild(el);
      setTimeout(() => {
        if (running) el.remove();
      }, 1400);
    };

    document.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      running = false;
      document.removeEventListener("mousemove", onMove);
      document.querySelectorAll(".sparkle-particle").forEach((n) => n.remove());
    };
  }, [enabled]);

  return null;
}
